var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "sui-table",
    { attrs: { basic: "very", compact: "" } },
    [
      _c(
        "sui-table-header",
        [
          _c(
            "sui-table-row",
            [
              _c("sui-table-header-cell"),
              _c("sui-table-header-cell"),
              _vm._l(_vm.columns, function (column, idx) {
                return _c("sui-table-header-cell", { key: idx }, [
                  _vm._v(" " + _vm._s(column) + " "),
                ])
              }),
              _c("sui-table-header-cell"),
            ],
            2
          ),
        ],
        1
      ),
      _vm.users
        ? _c(
            "sui-table-body",
            _vm._l(_vm.users, function (user, index) {
              return _c(
                "sui-table-row",
                { key: index },
                [
                  _c("sui-table-cell", { attrs: { collapsing: "" } }, [
                    _vm._v(_vm._s(index + 1)),
                  ]),
                  _c(
                    "sui-table-cell",
                    { attrs: { collapsing: "" } },
                    [
                      _c("sui-checkbox", {
                        on: {
                          change: function ($event) {
                            return _vm.handleSelectedUsers($event, user)
                          },
                        },
                      }),
                    ],
                    1
                  ),
                  _c("sui-table-cell", { attrs: { collapsing: "" } }, [
                    _c(
                      "div",
                      {
                        staticClass: "user-name",
                        on: {
                          click: function ($event) {
                            return _vm.handleEdit(user.id)
                          },
                        },
                      },
                      [
                        _c("span", { staticClass: "user-name-initials" }, [
                          _vm._v(
                            " " +
                              _vm._s(`${user.last_name}, ${user.first_name} `) +
                              " "
                          ),
                        ]),
                      ]
                    ),
                  ]),
                  _c("sui-table-cell", [_vm._v(_vm._s(user.email))]),
                  _c("sui-table-cell", [
                    _vm._v(
                      _vm._s(_vm.profileTypeName(user.profile.profile_type)) +
                        " "
                    ),
                  ]),
                  _c(
                    "sui-table-cell",
                    [
                      _c("sui-checkbox", {
                        attrs: { disabled: "" },
                        model: {
                          value: user.is_active,
                          callback: function ($$v) {
                            _vm.$set(user, "is_active", $$v)
                          },
                          expression: "user.is_active",
                        },
                      }),
                    ],
                    1
                  ),
                  _c("sui-table-cell", [
                    _vm._v(_vm._s(_vm._f("datetime")(user.last_login))),
                  ]),
                  _c(
                    "sui-table-cell",
                    { attrs: { collapsing: "" } },
                    [
                      _c("sui-icon", {
                        staticClass: "edit",
                        staticStyle: { color: "#8C979A" },
                        attrs: { name: "edit" },
                        on: {
                          click: function ($event) {
                            return _vm.handleEdit(user.id)
                          },
                        },
                      }),
                    ],
                    1
                  ),
                  _c(
                    "sui-table-cell",
                    { attrs: { collapsing: "" } },
                    [
                      _c(
                        "sui-dropdown",
                        { attrs: { simple: "" } },
                        [
                          _c(
                            "sui-dropdown-menu",
                            [
                              _c(
                                "sui-dropdown-item",
                                {
                                  on: {
                                    click: function ($event) {
                                      return _vm.handleEdit(user.id)
                                    },
                                  },
                                },
                                [
                                  _c("font-awesome-icon", {
                                    staticClass:
                                      "list-item-menu-icon pencil-alt",
                                    attrs: { icon: "pencil-alt" },
                                  }),
                                  _vm._v(" Edit "),
                                ],
                                1
                              ),
                              _c(
                                "sui-dropdown-item",
                                {
                                  on: {
                                    click: function ($event) {
                                      return _vm.handleDelete(user.id)
                                    },
                                  },
                                },
                                [
                                  _c("font-awesome-icon", {
                                    staticClass: "list-item-menu-icon trash",
                                    attrs: { icon: "trash-alt" },
                                  }),
                                  _vm._v(" Delete "),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              )
            }),
            1
          )
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }